/** Shared content width for all FIC /management screens (matches chrome + menu). */
export const LEADERSHIP_CONTENT =
  'max-w-[1500px] w-full mx-auto px-4 sm:px-8 py-6';
